export default __webpack_public_path__ + "424c00b802f461988f827da986df84e5.svg";